import Ripple from 'vuetify/lib/directives/ripple';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      {
        directives: [
          {
            def: Ripple,
            name: "ripple",
            rawName: "v-ripple.center",
            value: !_vm.disabled,
            expression: "!disabled",
            modifiers: { center: true },
          },
        ],
        staticClass: "file-picker-activator",
        class: {
          "file-picker-activator--focused": _vm.focused && !_vm.disabled,
          "file-picker-activator--disabled bg-gray-80--text": _vm.disabled,
          "text-error--text": _vm.isError,
        },
        attrs: { "data-qa": "file_picker_activator" },
      },
      [
        _c("div", { staticClass: "file-picker-activator__inner" }, [
          _c("div", {
            staticClass: "ui-icon-plus file-picker-activator__icon",
          }),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass:
                "d-flex flex-column text-body-1 text-center mt-2 file-picker-activator__text text-pre-line",
              class: { "text-secondary--text": !_vm.disabled && !_vm.isError },
              attrs: { "data-qa": "file_picker_activator_text" },
            },
            [_vm._v(_vm._s(_vm.text))]
          ),
        ]),
      ]
    ),
    _vm._v(" "),
    _vm.isError
      ? _c(
          "div",
          { staticClass: "text-subtitle-2 text-error--text text-center mt-2" },
          [_vm._v("\n    Загрузите направление\n  ")]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }